// extracted by mini-css-extract-plugin
export default {"button":"shareButton_button__-1Vem","large":"shareButton_large__NrFu7","textButton":"shareButton_textButton__vtMUO"};